import React from "react";
import { Table } from "antd";
import "./RegistrationTotalsTable.css";

const RegistrationTotalsTable = ({ data, isBusy, onDetail }) => {
  const columns = [
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      render: (text) => (text === "registration" ? "Registration" : "Program"),
      sorter: (a, b) => a.type.localeCompare(b.type),
      defaultSortOrder: "ascend",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: "Count",
      dataIndex: "count",
      key: "count",
      align: "right",
      sorter: (a, b) => a.count - b.count,
      render: (text) => text || 0,
    },
    {
      title: "Total Amount",
      dataIndex: "total_amount",
      key: "total_amount",
      align: "right",
      sorter: (a, b) => parseFloat(a.total_amount || 0) - parseFloat(b.total_amount || 0),
      render: (text) => `$${parseFloat(text || 0).toFixed(2)}`,
    },
    {
      title: "Last Timestamp",
      dataIndex: "last_timestamp",
      key: "last_timestamp",
      sorter: (a, b) => {
        if (!a.last_timestamp) return 1;
        if (!b.last_timestamp) return -1;
        return new Date(a.last_timestamp) - new Date(b.last_timestamp);
      },
      render: (text) => text || "N/A",
    },
  ];

  return (
    <div className="registration-totals-table">
      <Table
        columns={columns}
        dataSource={data}
        loading={isBusy}
        rowKey={(record) => `${record.type}-${record.id}`}
        onRow={(record) => ({
          onClick: () => onDetail(record),
          style: { cursor: "pointer" },
        })}
        pagination={{
          pageSize: 50,
          showSizeChanger: true,
          pageSizeOptions: ["20", "50", "100", "200"],
          showTotal: (total) => `Total ${total} items`,
        }}
      />
    </div>
  );
};

export default RegistrationTotalsTable;
